import { Accordion, AccordionDetails, AccordionSummary, Box, Button, ButtonBase, Dialog, DialogContent, DialogTitle, Grid, IconButton, LinearProgress, Theme, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import ViewProfileOverview from "./ViewProfileOverview";
import RMDetails from "./RMDetails";
import PersonalDetails from "./PersonalDetails";
import RelatedPersonDetails from "./RelatedPersonDetails";
import ContactDetails from "./ContactDetails";
import AdditionalKYCDetails from "./AdditionalKYCDetails";
import NomineeDetails from "./NomineeDetails";
import FatcaDetails from "./FatcaDetails";
import BankDetails from "./BankDetails";
import RiskProfileDetails from "./RiskProfileDetails";
import InvestmentPreferenceDetails from "./InvestmentPreferenceDetails";
import ServicePreferenceDetails from "./ServicePreferenceDetails";
import { useHistory } from "react-router";
import { getApplicationDetailsByClientCode } from "../../../redux-store/actions/investorProfile";
import DocumentDetails from "./DocumentDetails";
import { RootStateType } from "../../../redux-store/reducers";
import BreadCrum from "../../../lib/BreadCrum";
import { isModuleAllowed, maskInfo } from "../../../utils/utilityFunctions";
import NexEdgeInvPrefDetails from "./NexEdgeInvPrefDetails";
import Consent from "./Consent";
import { APPLICATION_TYPE, PHYSICAL_DIGITAL_FLOW, RISK_PROFILE_SOLEPROP, USER_ROLES } from "../../../utils/constant";
import { ArrowDropDown, Edit as EditIcon } from "@mui/icons-material";
import DistributorDetails from "../../ApplicationDetails/rmDetails";
import ContributorDetails from "../../NonIndividualApplicationDetails/ContributorDetails";
import AuthorizedSignatories from "../../NonIndividualApplicationDetails/AuthorisedSignatories";
import Fatca from "../../NonIndividualApplicationDetails/fatca";
import RiskProfile from "../../NonIndividualApplicationDetails/RiskProfile";
import InvPref from "../../NonIndividualApplicationDetails/InvPref";
import Documents from "../../NonIndividualApplicationDetails/Document";
import Ubo from "../../NonIndividualApplicationDetails/ubo";
import NonIndividualContactDetails from "../../NonIndividualApplicationDetails/ContactDetails"
import NonIndividualBankDetails from "../../ApplicationDetails/BankDetails";
import { showError } from "../../../redux-store/actions/auth";
import { getDataMasters } from "../../../redux-store/actions/onBoarding";
import { DataMaster, DataMasters } from "../../../redux-store/types/api-types";
import ClientInvestmentPreview from "../../ApplicationDetails/ClientInvestmentPreview";
import ClientInvestmentDetails from "../../NonIndividualApplicationDetails/ClientInvestmentDetails";
// // import ClientInvInf from "../../investors/ClientInvInf";
// import NonIndclientInvInfrmation from "../../NonIndividualInvestor/NonIndClientIndInf";
import CloseIcon from "@mui/icons-material/Close";


function IndividualProfileSections({
    viewProfileData = {},
    dataMasters,
    // showEditButton,
    // onEditClick,
}: {
    viewProfileData: any,
    dataMasters: DataMaster,
    // showEditButton: boolean;
    // onEditClick: () => void;
}): JSX.Element {
    const { role } = useSelector((state: RootStateType) => state.auth);
    const isInvestor = USER_ROLES.INVESTOR.includes(role);
    return (
        <>
            {/* {showEditButton && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                    <ButtonBase
                        onClick={onEditClick}
                        sx={(theme: Theme) => ({
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                            borderRadius: '12px',
                            padding: '8px 16px',
                            color: '#6c737f',
                            fontWeight: 600,
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                            },
                        })}
                    >
                        <EditIcon fontSize="small" />
                        <Typography
                            variant="body_500"
                            sx={{
                                fontWeight: 600,
                                color: '#6c737f',
                            }}
                        >
                            Edit/Add Client Investment Information
                        </Typography>
                    </ButtonBase>
                </Box>
            )} */}
            {/* {!isInvestor && (
                <Box id="Consent">
                    <Consent overviewData={viewProfileData ?? {}} />
                </Box>
            )} */}
            <Box id="Overview">
                <ViewProfileOverview overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="RM Details">
                <RMDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Personal Details'>
                <PersonalDetails overviewData={viewProfileData ?? {}} />
            </Box>
            {/* <Box id="Details of Related Person">
                <RelatedPersonDetails overviewData={viewProfileData ?? {}} />
            </Box> */}
            <Box id='Contact Details'>
                <ContactDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Additional KYC'>
                <AdditionalKYCDetails overviewData={viewProfileData ?? {}} dataMasters={dataMasters} />
            </Box>
            <Box id='Nominee Details'>
                <NomineeDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='FATCA Declaration'>
                <FatcaDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id="Bank Details">
                <BankDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Risk Profile'>
                <RiskProfileDetails overviewData={viewProfileData ?? {}} />
            </Box>
            {/* <Box id='Client Investment Information'>
                <ClientInvestmentPreview applicationData={viewProfileData ?? {}} onEditClick={onEditClick} />
            </Box> */}
            {/* <Box id='Investment Preference'>
                <InvestmentPreferenceDetails overviewData={viewProfileData ?? {}} />
            </Box> */}
            <Box id='Upload Documents'>
                <DocumentDetails overviewData={viewProfileData ?? {}} />
            </Box>
        </>
    )
}

function NonIndividualProfileSections({
    viewProfileData = {},
    dataMasters,
    // showEditButton,
    // onEditClick,
}: {
    viewProfileData: any,
    dataMasters: DataMaster,
    // showEditButton: boolean;
    // onEditClick: () => void;
}): JSX.Element {
    return (
        <>
            {/* {showEditButton && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                    <ButtonBase
                        onClick={onEditClick}
                        sx={(theme: Theme) => ({
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 1,
                            borderRadius: '12px',
                            padding: '8px 16px',
                            color: '#6c737f',
                            fontWeight: 600,
                            transition: 'background-color 0.2s ease',
                            '&:hover': {
                                backgroundColor: theme.palette.action.hover,
                            },
                        })}
                    >
                        <EditIcon fontSize="small" />
                        <Typography
                            variant="body_500"
                            sx={{
                                fontWeight: 600,
                                color: '#6c737f',
                            }}
                        >
                            Edit/Add Client Investment Information
                        </Typography>
                    </ButtonBase>
                </Box>
            )} */}
            {/* {PHYSICAL_DIGITAL_FLOW && (
                <Box id="Consent">
                    <Consent overviewData={viewProfileData ?? {}} />
                </Box>
            )} */} 
            <Box id="RM Details">
               <RMDetails overviewData={viewProfileData ?? {}} />
            </Box>
            <Box id='Entity Details'>
                <ContributorDetails applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id="Contact Details">
                <NonIndividualContactDetails applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id='Investor’s Bank Details'>
                <NonIndividualBankDetails banks={viewProfileData?.banks ?? []} />
            </Box>
            <Box id='Authorised Signatory'>
                <AuthorizedSignatories groups={viewProfileData?.groups ?? []} application={viewProfileData} />
            </Box>
            <Box id='Declaration of UBO'>
                <Ubo application={viewProfileData ?? {}} dataMasters={dataMasters} />
            </Box>
            <Box id='FATCA'>
                <Fatca applicants={viewProfileData?.applicants ?? []} />
            </Box>
            <Box id="Risk Profile">
                {viewProfileData?.applicants?.[0]?.onboardingSubType === RISK_PROFILE_SOLEPROP ? <RiskProfileDetails overviewData={viewProfileData ?? {}} /> : <RiskProfile application={viewProfileData ?? {}} />}
            </Box>
            {/* <Box id='Client Investment Information'>
                <ClientInvestmentDetails applicationData={viewProfileData ?? {}} onEditClick={onEditClick} />
            </Box> */}

            {/* <Box id='Investment Preference'>
                <InvPref application={viewProfileData ?? {}} />
            </Box> */}
            <Box id='Document Details'>
                <Documents application={viewProfileData ?? {}} />
            </Box>
        </>
    )
}


export default function ViewProfile(): JSX.Element {
    const history = useHistory();
    const { state, pathname: pathName } = history.location;
    const [onboardingType, setOnboardingType] = useState<string>('');
    const [applicationType, setApplicationType] = useState<string>('')
    const [loading, setLoading] = useState(false);
    const [viewProfileData, setViewProfileData] = useState();
    const dispatch = useDispatch();
    const [dataMasters, setDataMasters] = useState<DataMaster>({} as DataMaster);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editModalType, setEditModalType] = useState<'individual' | 'nonIndividual' | null>(null);

    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);
    const {
        selectedPortfolio
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clientCode = ((state as any)?.clientCode ?? '') as string;
    const portfolio = ((state as any)?.portfolioId ?? '') as string;
    // console.log('clientcode', clientCode);

    const fetchViewProfileData = async () => {
        if (!clientCode) {
            dispatch(showError('Client code is not Found'));
            return;
        }
        setLoading(true);

        const ans = (await dispatch(getApplicationDetailsByClientCode({
            clientCode: clientCode,
            portfolio: selectedPortfolio?.value || portfolio
        }))) as any;
        if (!ans) {
            dispatch(showError('Something went wrong while fetching profile details'));
            return;
        }
        const modifiedResponse = {
            ...ans,
            name: maskInfo(ans?.name),
            pan: maskInfo(ans?.pan),
            mobile: maskInfo(ans?.mobile),
            email: maskInfo(ans?.email),
            countryCode:maskInfo(ans?.countryCode),
            rm: {
                ...ans.rm,
                user: {
                    ...ans.rm?.user,
                    email: maskInfo(ans.rm?.user?.email),
                    phone: maskInfo(ans.rm?.user?.phone),
                    firstName: maskInfo(ans.rm?.user?.firstName),
                }
            },
            applicants: ans?.applicants?.map((ele: any) => ({
                ...ele,
                firstName: maskInfo(ele?.firstName),
                lastName: maskInfo(ele?.lastName),
                panNo: maskInfo(ele?.panNo),
                email: maskInfo(ele?.email),
                mobile: maskInfo(ele?.mobile),
                kraMobileNumber: maskInfo(ele?.kraMobileNumber),
            })) ?? [],
            banks: ans?.banks.map((ele: any) => ({
                ...ele,
                bankAccountNumber: maskInfo(ele?.bankAccountNumber),
                ifscCode: maskInfo(ele?.ifscCode),
                micrCode: maskInfo(ele?.micrCode),
            })) ?? [],
        }

        setOnboardingType(modifiedResponse?.onboardingType);
        setApplicationType(modifiedResponse?.applicationType);

        setViewProfileData(modifiedResponse);
        setLoading(false);

    }
    useEffect(() => {
        fetchViewProfileData();
        (async () => {
            const res = (await dispatch(getDataMasters())) as unknown as DataMasters;
            if (res?.data) {
                setDataMasters(res?.data ?? {});
            }
        })()
    }, [])

    const initialRouter = pathName.split('/').filter((item) => item !== '')
    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            // warning: true
        },
        {
            name: `${initialRouter[1]}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode: clientCode || ""
            }
        },
        {
            name: 'View Profile',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: clientCode || ""
            }
        }
    ] : [])

    const investorRouterPath = [
        {
            name: `Dashboard`,
            path: '/investor-dashboard',
            // warning: true
        },
        {
            name: 'View Profile',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode: clientCode || ""
            }
        }
    ]

    const individualProfileHeaders = [
        'Overview',
        'RM Details',
        "Personal Details",
        // "Details of Related Person",
        "Contact Details",
        "Additional KYC",
        "Nominee Details",
        "FATCA Declaration",
        "Bank Details",
        "Risk Profile",
        // "Investment Preference",
        // 'Client Investment Information',
        // "Service Preference",
        "Upload Documents",
    ]

    const nonIndividualProfileHeaders = [
        "RM Details",
        "Entity Details",
        "Contact Details",
        "Investor’s Bank Details",
        "Authorised Signatory",
        "Declaration of UBO",
        "FATCA",
        "Risk Profile",
        // "Investment Preference",
        // 'Client Investment Information',
        "Document Details"
    ]

    const viewProfileHeaders = [
        ...(PHYSICAL_DIGITAL_FLOW ? ['Consent'] : []),
        ...(
            `${applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL ? individualProfileHeaders : nonIndividualProfileHeaders
        )
    ]



    const scrollToContent = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const [activeHeader, setActiveHeader] = useState(viewProfileHeaders[0]);
    const [expanded, setExpanded] = useState<string | false>(false);

    const showEditButton = useMemo(() => {
        const isInvestorDashboardRoute = pathName.includes("/investor-dashboard/view-profile");
        const isInvestorProfileRoute = pathName.includes("/investor-profile/") && pathName.includes("/view-profile");
        const isInvestorRole = USER_ROLES.INVESTOR.includes(role);
        const isRMRole = [USER_ROLES.RM].includes(role);

        // Show button if:
        //  Investor dashboard route AND investor role, OR
        //  Investor profile route (RM viewing) AND (investor role OR RM role)
        return (isInvestorDashboardRoute && isInvestorRole) ||
            (isInvestorProfileRoute && (isInvestorRole || isRMRole));
    }, [pathName, role]);

    const handleOpenEdit = (type: 'individual' | 'nonIndividual') => {
        setEditModalType(type);
        setEditModalOpen(true);
    };

    const handleCloseEdit = () => {
        setEditModalType(null);
        setEditModalOpen(false);
    };

    const handleAccordionChange = (panel: string) => (
        event: React.SyntheticEvent,
        isExpanded: boolean
    ) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleHeaderClick = (header: string) => {
        setExpanded(false);

        setActiveHeader(header);
        scrollToContent(header);
    };

    return (
        <>
            {loading ? <LinearProgress /> : <Box>

                <Box sx={{ width: '100%' }}>
                    <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
                </Box>
                {/* Main Data */}
                <Box sx={(theme: Theme) => ({
                    p: { xs: "15px", md: "35px 35px 35px 25px" },
                    border: `1px solid ${theme.palette.text.secondary}26`,
                    borderRadius: "15px",
                    background: theme.palette.background.paper,
                    mt: '20px'
                })}>
                    <Grid container columnSpacing={'15px'} >
                        <Grid item xs={12} md={4} lg={3} sx={{ padding: 0, position: 'sticky', top: '0', height: 'calc(100vh - 60px)', overflowY: 'auto', display: { xs: 'none', md: 'block' } }}>
                            <Box>
                                {viewProfileHeaders.map((header: string, index: number) => (
                                    <Box
                                        key={index}
                                        sx={(theme: Theme) => (
                                            {
                                                mt: index !== 0 ? '15px' : 0,
                                                backgroundColor: activeHeader === header ? theme.palette.primary[500] : theme.palette.common.white,
                                                borderRadius: '8px',
                                                padding: '10px 20px'
                                            })}

                                    >
                                        <Typography component={'span'} onClick={() => {
                                            setActiveHeader(header);
                                            scrollToContent(header);
                                        }} variant="body_500" sx={(theme: Theme) => ({
                                            color: activeHeader === header ? 'textDark.primary' : 'text.secondary',
                                            cursor: 'pointer'
                                        })}>{header}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={4}
                            lg={3}
                            sx={{ display: { xs: 'block', md: 'none' }, paddingBottom: 2 }}
                        >
                            <Accordion
                                expanded={expanded === 'panel1a'}
                                onChange={handleAccordionChange('panel1a')}
                                sx={{
                                    boxShadow: 'none',
                                    '&:before': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <AccordionSummary
                                    // expandIcon={<ArrowDropDown />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    sx={{
                                        padding: 0,
                                    }}
                                ><Box
                                    sx={(theme) => ({
                                        backgroundColor: theme.palette.primary[50],
                                        border: `1px solid ${theme.palette.primary[500]}`,
                                        borderRadius: '8px',
                                        padding: '10px 20px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%',
                                        alignItems: 'center'
                                    })}
                                >
                                        <Typography
                                            component="span"
                                            variant="body_500"
                                            onClick={() => handleHeaderClick(activeHeader)}
                                            sx={(theme) => ({
                                                color: theme.palette.primary[500],
                                                cursor: 'pointer',
                                            })}
                                        >
                                            {activeHeader}
                                        </Typography>
                                        <ArrowDropDown
                                            sx={(theme) => ({
                                                color: theme.palette.primary[500],
                                                transition: 'transform 0.3s ease-in-out',
                                                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'
                                            })}
                                        />
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails
                                    sx={(theme) => ({
                                        paddingX: 1,
                                        paddingY: 2,
                                        border: `1px solid ${theme.palette.text.secondary}26`,
                                        borderRadius: 3
                                    })}
                                >
                                    <Box>
                                        {viewProfileHeaders.map((header, index) => (
                                            <Box
                                                key={index}
                                                sx={(theme) => ({
                                                    mt: index !== 0 ? '15px' : 0,
                                                    backgroundColor:
                                                        activeHeader === header
                                                            ? theme.palette.primary[500]
                                                            : theme.palette.common.white,
                                                    borderRadius: '8px',
                                                    padding: '10px 20px',
                                                })}
                                            >
                                                <Typography
                                                    component="span"
                                                    variant="body_500"
                                                    onClick={() => handleHeaderClick(header)}
                                                    sx={(theme) => ({
                                                        color:
                                                            activeHeader === header
                                                                ? theme.palette.textDark?.primary ?? theme.palette.text.primary
                                                                : theme.palette.text.secondary,
                                                        cursor: 'pointer',
                                                    })}
                                                >
                                                    {header}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid item
                            container
                            xs={12}
                            md={8}
                            lg={9}
                        >
                            {viewProfileData && (<Box component={'div'} sx={(theme: Theme) => ({ padding: '35px', border: `1px solid ${theme.palette.text.secondary}26`, borderRadius: '15px', backgroundColor: `${theme.palette.common.white}`, width: '100%' })}>
                                {
                                    (`${applicationType ?? ""}`.toLowerCase() === APPLICATION_TYPE.INDIVIDUAL) ? (
                                        <IndividualProfileSections
                                            viewProfileData={viewProfileData}
                                            dataMasters={dataMasters}
                                            // showEditButton={showEditButton}
                                            // onEditClick={() => handleOpenEdit('individual')}
                                        />
                                    ) : (
                                        <NonIndividualProfileSections
                                            viewProfileData={viewProfileData}
                                            dataMasters={dataMasters}
                                            // showEditButton={showEditButton}
                                            // onEditClick={() => handleOpenEdit('nonIndividual')}
                                        />
                                    )
                                }

                            </Box>)}


                        </Grid>
                    </Grid>

                </Box>
            </Box>}
            {/* <Dialog
                open={editModalOpen}
                onClose={handleCloseEdit}
                fullWidth
                maxWidth="xl"
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        minHeight: "75vh",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    },
                }}
            >
                
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        fontWeight: 600,
                        px: 3,
                        py: 2,
                        borderBottom: "1px solid #e0e0e0",
                    }}
                >
                    Edit Client Investment Information
                    <IconButton onClick={handleCloseEdit}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                
                <DialogContent
                    dividers
                    sx={{
                        px: 3,
                        py: 2,
                        backgroundColor: "#fafafa",
                        overflowY: "auto",
                        border: "1px solid #e0e0e0",
                        borderTop: "none",
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "white",
                            borderRadius: 2,
                            p: 3,
                            border: "1px solid #dadada",
                        }}
                    >
                        {editModalType === "individual" && (
                            <ClientInvInf
                                isViewProfile={true}
                                onClose={handleCloseEdit}
                                onSuccess={fetchViewProfileData}
                                applicationId={(viewProfileData as any)?.id || (viewProfileData as any)?.applicationId}
                                applicationData={viewProfileData}
                            />
                        )}
                        {editModalType === "nonIndividual" && (
                            <NonIndclientInvInfrmation
                                isViewProfile={true}
                                onClose={handleCloseEdit}
                                onSuccess={fetchViewProfileData}
                                applicationId={(viewProfileData as any)?.id || (viewProfileData as any)?.applicationId}
                                applicationData={viewProfileData}
                            />
                        )}
                    </Box>
                </DialogContent>
            </Dialog> */}

        </>
    )
}
